var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"menu",class:'menu-' + _vm.location},[_c('WpNaviLinks',{attrs:{"link-class":_vm.linkClass,"menu":_vm.menu}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }